import React from 'react'

import DigitalRightCreateSections from './sectionsLists/DigitalRightCreateSections'
import PostsRightCreateSections from './sectionsLists/PostsRightCreateSections'
import OtherRightCreateSections from './sectionsLists/OtherRightCreateSections'
import OnsiteRightCreateSections from './sectionsLists/OnsiteRightCreateSections'

import { RIGHT_TYPE, RIGHT_TYPE_DIGITAL, RIGHT_TYPE_ONSITE, RIGHT_TYPE_OTHER, RIGHT_TYPE_POSTS } from '../../fields'

const RightCreateFormContent = ({ formik }) => {
  const { values } = formik

  const rightType = values[RIGHT_TYPE]
  if (rightType === RIGHT_TYPE_DIGITAL) {
    return <DigitalRightCreateSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_POSTS) {
    return <PostsRightCreateSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_OTHER) {
    return <OtherRightCreateSections formik={formik} />
  } else if (rightType === RIGHT_TYPE_ONSITE) {
    return <OnsiteRightCreateSections formik={formik} />
  }

  return null
}

export default RightCreateFormContent
